module.exports = __webpack_public_path__ + "static/media/zoom-in.35a53305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/zoom-in.svg
// module id = 3843
// module chunks = 7